export const invoicePreviewContainerWrapperCSSId = 'invoice-preview-container-wrapper';
export const editSectionWrapperCSSClass = 'edit-section-wrapper';
export const editSectionHoveredCSSClass = 'edit-section-hovered';
export const editableAreaCSSClass = 'editable-area';
export const editModeCSSClass = 'edit-mode';
export const invisibleHTMLSectionCSSClass = 'invisible-html-section';
export const removedHTMLSectionCSSClass = 'removed-html-section';

// Meta properties
export const isHiddenMeta = 'is-hidden';
export const isRemovedMeta = 'is-removed';
